const URL_PREFIX = '/s';

export default {
  OVERVIEW: {
    ROOT: `${URL_PREFIX}/overview`
  }
};

export { URL_PREFIX };
